import { FC } from 'react'
import { Route, Routes } from 'react-router'
import ModuleGuard, { ModuleIndexRedirect } from 'components/shared/ModuleGuard'
import AlertList from '../components/AlertList'

export const AlertRoutes: FC = () => {
 return (
  <Routes>
   <Route
    path=""
    element={
     <ModuleIndexRedirect
      options={[
       { path: 'new-listing', module: 'alert_new_listing' },
       { path: 'sold-listing', module: 'alert_neighbourhood' },
       { path: 'open-house-listing', module: 'alert_open_house' },
       { path: 'price-drop', module: 'alert_price_drop' },
      ]}
     />
    }
   />
   <Route
    path="new-listing"
    element={
     <ModuleGuard module="alert_new_listing">
      <AlertList controlType="new_listing_alert" type="forsale" />
     </ModuleGuard>
    }
   />
   <Route
    path="sold-listing"
    element={
     <ModuleGuard module="alert_neighbourhood">
      <AlertList controlType="neighbourhood_alert" type="sold" />
     </ModuleGuard>
    }
   />
   <Route
    path="open-house-listing"
    element={
     <ModuleGuard module="alert_open_house">
      <AlertList controlType="price-open_house_alert" type="openhouse" />
     </ModuleGuard>
    }
   />
   <Route
    path="price-drop"
    element={
     <ModuleGuard module="alert_price_drop">
      <AlertList controlType="price_drop_alert" type="price-drop" />
     </ModuleGuard>
    }
   />
  </Routes>
 )
}
